"use client";

import React, { useState, useCallback } from "react";
import "@/styles/faq.css";

const ChevronIcon = () => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M5 7.5L10 12.5L15 7.5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const FaqItem = ({ item }) => {
    const [open, setOpen] = useState(false);

    // Convert newlines in answers to <br> for proper display
    const formatAnswer = (text) => {
        if (!text) return "";
        return text.split("\n").map((line, i) => (
            <React.Fragment key={i}>
                {line}
                {i < text.split("\n").length - 1 && <br />}
            </React.Fragment>
        ));
    };

    return (
        <div className="faq-item">
            <div className="faq-item-header" onClick={() => setOpen(!open)}>
                <span className="faq-item-question">{item.question}</span>
                <span className={`faq-item-icon ${open ? "open" : ""}`}>
                    <ChevronIcon />
                </span>
            </div>
            <div className={`faq-item-answer ${open ? "open" : ""}`}>
                <div className="faq-item-answer-inner">{formatAnswer(item.answer)}</div>
            </div>
        </div>
    );
};

const FaqScreen = ({ faqData = [] }) => {
    const [activeCategoryId, setActiveCategoryId] = useState(
        faqData.length > 0 ? faqData[0]._id : null
    );

    const activeCategory = faqData.find((c) => c._id === activeCategoryId);

    const handleTabClick = useCallback((categoryId) => {
        setActiveCategoryId(categoryId);
    }, []);

    if (!faqData || faqData.length === 0) {
        return (
            <div className="faq-page">
                <div className="faq-hero">
                    <h1>سوالات متداول</h1>
                    <p>پاسخ سوالات پرتکرار شما</p>
                </div>
                <div className="faq-empty">
                    <p>در حال حاضر سوالی ثبت نشده است.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="faq-page">
            <div className="faq-hero">
                <h1>سوالات متداول</h1>
                <p>پاسخ سوالات پرتکرار شما</p>
            </div>

            {/* Category Tabs */}
            <div className="faq-tabs">
                {faqData.map((category) => (
                    <button
                        key={category._id}
                        className={`faq-tab ${activeCategoryId === category._id ? "active" : ""
                            }`}
                        onClick={() => handleTabClick(category._id)}
                    >
                        {category.name}
                    </button>
                ))}
            </div>

            {/* Items for selected category */}
            <div className="faq-content">
                {activeCategory?.items?.length > 0 ? (
                    activeCategory.items.map((item) => (
                        <FaqItem key={item._id} item={item} />
                    ))
                ) : (
                    <div className="faq-empty">
                        <p>سوالی در این دسته‌بندی ثبت نشده است.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default FaqScreen;
